import React from "react";
import { ReactComponent as ChevronIcon } from "Assets/icon/icon-chevron.svg";
import { Button } from "components/ui";
import { IconButton } from "../../../../../components/ui/IconButton";
import styles from "./pagination.module.scss";
import _ from "lodash";
import { useTranslation } from "lib/i18n/use-translation";

type PaginationFooterProps = {
  classNames?: string;
  numberOfPages: number;
  currentActivePage: number;
  onPageNumberClick?: (pageNumber: number) => void;
  onNextClick?: () => void;
  onPreviousClick?: () => void;
};
const PaginationFooter = ({
  classNames,
  numberOfPages,
  currentActivePage,
  onPageNumberClick,
  onNextClick,
  onPreviousClick,
}: PaginationFooterProps) => {
  const { t } = useTranslation(["admin"]);
  let firstPage: number = 1;
  //Maximum pages is the number of pages shown in the footer at any one time, except for total number of pages less than this number.
  let maximumPages: number = 5;

  //Carousel effect always ensure the active page is in the middle.
  //If current page is 1, 2 or 3
  if (
    maximumPages - currentActivePage > 1 ||
    numberOfPages - maximumPages < 1
  ) {
    firstPage = 1;

    //If current page is totalPages -1, totalPages - 2 or totalPages - 3
  } else if (numberOfPages - currentActivePage < maximumPages - 3) {
    firstPage = numberOfPages - maximumPages + 1;

    //Otherwise, active page is always in the middle
  } else {
    firstPage = currentActivePage - 2;
  }

  return (
    <div className={`${styles["pagination-footer"]} sans ${classNames}`}>
      <IconButton
        disabled={currentActivePage === 1}
        onClick={onPreviousClick}
        aria-label={t("admin:pagination.previousPage")}
        icon={
          <ChevronIcon
            height={16}
            width={16}
            alt="left icon"
            className={styles["arrow-left"]}
          />
        }
      />

      {_.range(
        firstPage,
        //  < 1 ? 1 : firstPage
        numberOfPages + 1,
        1
      )
        .slice(0, maximumPages)
        .map((pageNumber) => (
          <Button
            key={pageNumber}
            onClick={() => onPageNumberClick?.(pageNumber)}
            variant="secondary"
            size="small"
            className={
              currentActivePage === pageNumber ? styles.active : undefined
            }
          >
            {pageNumber}
          </Button>
        ))}

      <IconButton
        disabled={currentActivePage >= numberOfPages}
        onClick={onNextClick}
        className={styles.right}
        aria-label={t("admin:pagination.nextPage")}
        icon={<ChevronIcon height={16} width={16} alt="right icon" />}
      />
    </div>
  );
};

export default PaginationFooter;
